<template>

<div v-cloak class="faqs">

  <draggable v-model="faqs" @end="dragEnd" :options="{ handle: isAdmin ? '.question' : '.question-disabled' }">
    <div v-for="faq in faqs" v-bind:key="faq.id" :id="'faq-' + faq.id" class="push-half--bottom">
      <h3 class="question flush--bottom">
        <div class="button-group flush--bottom push-half--top push-half--right float--right" v-if="isAdmin">
          <button class="button button--small button--light" @click="edit(faq)">{{ $_('edit') }}</button>
          <button class="button button--small button--light" @click="remove(faq)">{{ $_('delete') }}</button>
        </div>
        <a @click="openFaq(faq)" class="card card--question flush--bottom"><i class="fa fa-sm" :class="{ 'fa-plus': !faq.show, 'fa-minus': faq.show }"></i> <span>{{ faq.question }}</span></a>
      </h3>
      <div class="card card--answer card--large" v-show="faq.show" v-html="faq.answer"></div>
    </div>
  </draggable>

  <button type="button" class="button button--primary" v-on:click="enableNew" v-if="isAdmin && !showNew">{{ $_('add_new_faq') }}</button>

  <form class="push--top" v-if="isAdmin && showNew" v-on:submit.prevent="onSubmit('faq')" data-vv-scope="faq">
    <h2>{{ (faq.id) ? `${$_('edit_faq')} ${faq.id}` : $_('add_new_faq') }}</h2>
    <div class="form">
      <div class="form__line push-half--bottom">
        <div class="form__field">
          <label for="question">{{ $_('question') }}:</label>
          <input type="text" v-validate="'required'" name="question" id="question" v-model.number="faq.question" class="field field--text" :class="{ 'parsley-error': errors.has('faq.question') }">
          <span v-show="errors.has('faq.question')" class="parsley-errors-list ">{{ errors.first('faq.question') }}</span>
        </div>
      </div>
      <div class="form__line push-half--bottom">
        <div class="form__field">
          <label for="answer">{{ $_('answer') }}:</label>
          <input type="hidden" name="answer" id="answer" v-model="faq.answer" :value.prop="faq.answer" v-validate="'required'" class="field field--text" :class="{ 'parsley-error': errors.has('faq.answer') }" />
          <trix-editor inputId="answer" @trix-initialize="trixInit" @trix-change="trixChange" @trix-file-accept="trixPreUpload" @trix-attachment-add="trixUpload"></trix-editor>
          <span v-show="errors.has('faq.answer')" class="parsley-errors-list ">{{ errors.first('faq.answer') }}</span>
        </div>
      </div>
    </div>
    <div class="form__line flush--bottom">
      <button type="submit" class="button button--primary">{{ $_('save') }}</button>
      <button type="button" class="button button--default" @click="disableNew">{{ $_('cancel') }}</button>
    </div>
  </form>
  <div class="form__line push--top flush--bottom" v-if="error">
    <div class="form__field">
      <div class="parsley-error">{{ error }}</div>
    </div>
  </div>
</div>

</template>

<script>
import 'trix'
import 'trix/dist/trix.css'
import draggable from 'vuedraggable'

export default {
  name: 'faq',
  components: {
    draggable
  },
  data () {
    return {
      user: user,
      order: [],
      faqs: [],
      error: null,
      showNew: false,
      faq: {
        id: null,
        question: '',
        answer: '',
        sort_priority: null
      }
    }
  },
  computed: {
    isAdmin () {
      return user && user.admin === 1;
    }
  },
  mounted () {
    this.getFaqs();
  },
  methods: {
    getFaqs: function() {
      var self = this;
      this.$http.get("/api/v1/faq").then(
        function(response) {
          const hash = window.location.hash ? window.location.hash.replace('#', '').replace('_', '') : null;
          const id = hash ? parseInt(hash, 10) : null;
          self.faqs = response.data.faqs.map(f => { f.show = id && f.id === id ? true : false; return f; });
          if (id) {
            setTimeout(function() {
              const el = self.$el.querySelector(`#faq-${id}`);
              if (el) el.scrollIntoView();
            }, 300)
          }
        },
        function(error) {
          console.error(error);
        }
      )
    },
    openFaq (faq) {
      if (faq.show === undefined) {
        faq.show = false;
      }
      faq.show = !faq.show;
      window.location.hash = faq.show ? faq.id : `_`;
    },
    enableNew: function() {
      var self = this;
      this.showNew = true;
      setTimeout(function() {
        const el = self.$el.querySelector(`form`);
        if (el) el.scrollIntoView();
      }, 300);
    },
    disableNew: function() {
      this.showNew = false;
      this.clearNew();
    },
    clearNew: function() {
      this.faq = {
        id: null,
        question: '',
        answer: '',
        sort_priority: null
      };
      this.error = null;
    },
    trixInit () {
      const el = document.querySelector("trix-editor");
      if (el) {
        el.editor.loadHTML(this.faq.answer);
      }
    },
    trixChange (event) {
      this.faq.answer = event.srcElement.innerHTML;
    },
    trixPreUpload (event) {
      event.preventDefault();
      return;
    },
    trixUpload (event) {
      var self = this;
      if (event.attachment.file) {
        console.log(event.attachment, event.attachment.file);
        // uploadFileAttachment(event.attachment)
        var formData = new FormData();
        formData.append('file', event.attachment.file);
        self.$http.post(`/api/v1/faq/${self.faq.id}/upload`, formData, { emulateJSON: true }).then(
          function(response) {
            if (response.data.url) {
              var attributes = {
                url: response.data.url,
                href: response.data.url + "?content-disposition=attachment"
              };
              event.attachment.setAttributes(attributes)
            }
          },
          function(error) {
            console.error(error);
            self.error = error.response.data;
          }
        )
      }
    },
    onSubmit: function(scope) {
      var self = this;
      self.$validator.validateAll(scope).then(function(result) {
        if (!result) {
          return false;
        }
        var data = {
          id: self.faq.id ? self.faq.id : null,
          question: self.faq.question,
          answer: self.faq.answer,
          sort_priority: self.faq.sort_priority,
        };
        if (data.id) {
          self.update(data)
        } else {
          self.post(data);
        }
      });
    },
    post: function(data) {
      var self = this;
      self.$http.post('/api/v1/faq', data).then(
        function(response) {
          if (response.data.status) {
            self.getFaqs();
            self.openFaq({ id: response.data.status });
            self.disableNew();
            self.clearNew();
          }
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      );
    },
    update: function(data) {
      var self = this;
      self.$http.put('/api/v1/faq/' + data.id, data).then(
        function(response) {
          if (response.data.status) {
            self.getFaqs();
            self.openFaq({ id: self.faq.id });
            self.disableNew();
            self.clearNew();
          }
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      );
    },
    edit: function(faq) {
      if (this.showNew && this.faq.id == faq.id) {
        this.disableNew();
      } else {
        this.faq = JSON.parse(JSON.stringify(faq));
        this.error = null;
        this.trixInit();
        this.enableNew();
      }
    },
    remove: function(data) {
      if (!confirm(this.$_('faq_delete_confirmation'))) { return false; }
      var self = this;
      self.$http.delete('/api/v1/faq/' + data.id).then(
        function(response) {
          if (response.data.status) {
            self.getFaqs();
          }
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      )
    },
    dragEnd (a) {
      var self = this;
      const toUpdate = this.faqs.map((f, i) => { return { id: f.id, sort_priority: i+1 }});
      self.$http.patch('/api/v1/faq/updateSort', toUpdate).then(
        function(response) {
        },
        function(error) {
          console.error(error);
          self.error = error.response.data;
        }
      )
    },
    dragMove (a) {
      console.log('drag move', a)
    }
  }
}

</script>

<style lang="scss">
@import '../../../css/vars';

.faqs {
  .question {
    display: block;

    .button-group {
      position: relative;
      top: -5px;
    }
  }
  .card--question {
    display: block;
    color: inherit;
    font-weight: normal;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background: #f9f9f9;
    }

    i.fa {
      margin-right: 0.5rem;
      font-size: 1rem;
      color: $color-primary;
    }
  }
  .card--answer {
    background: $color-grey-lightest;
    border-top: 1px solid $color-grey-2;
    // background: #f6f6f6;

    :last-child,
    figure {
      margin-bottom: 0;
    }
    .attachment__caption {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/FAQ.vue